import React from 'react';

export const FullscreenLayout = ({
  children,
  header,
  footer,
}: {
  children: React.ReactNode;
  header: React.ReactNode;
  footer: React.ReactNode;
}) => (
  <div className="h-dvh flex flex-col justify-between">
    {header}
    <div className="flex-1 bg-accent-foreground">{children}</div>
    {footer}
  </div>
);
